import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import {
  hideLogin,
  resetLoginForm
} from 'src/actions/login'

import RequireUserOnGuestList from 'containers/RequireUserOnGuestList'
import HobnobModal from 'components/common/HobnobModal'

class LoginModal extends React.Component {
  render () {
    const { dispatch, open } = this.props
    const onSubscribeSuccessActions = [hideLogin(), resetLoginForm()]
    const onClose = () => dispatch(hideLogin(true))
    const containerStyles = {
      padding: '10px 10px 15px'
    }

    return (
      <HobnobModal show={open} onClose={onClose} containerStyles={containerStyles}>
        <RequireUserOnGuestList onSubscribeSuccessActions={onSubscribeSuccessActions} />
      </HobnobModal>
    )
  }
}

LoginModal.propTypes = {
  open: PropTypes.bool,
  dispatch: PropTypes.func
}

function mapStateToProps ({ frontend }) {
  return {
    open: frontend.showLogin
  }
}

export default connect(mapStateToProps)(LoginModal)



// WEBPACK FOOTER //
// ./src/containers/LoginModal.jsx